import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Login from '../components/Login';
import '../styles/Login.css';

const Acceso: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
      <main className="login-main">
        <Login />
      </main>
      <Footer />
    </div>
  );
};

export default Acceso;
